import React, { useState } from "react";
import { Dialog, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { GB, NL } from "country-flag-icons/react/3x2";
import CustomModal from "../../modals/CustomModal";

const MaatwerkErrorModal = ({
  visible,
  setVisible,
  errorMsg,
  unsetRequestId,
}) => {
  const { i18n, t } = useTranslation();

  return (
    <CustomModal
      visible={visible}
      setVisible={setVisible}
      title="Aanvraag mislukt"
      btnText={"Annuleer"}
      btnColor={"#439BD9"}
      btnOnClick={() => {
        unsetRequestId();
        setVisible(false);
      }}
      width="500px"
    >
      Aanvraag mislukt: <span>{errorMsg}</span>
    </CustomModal>
  );
};

export default MaatwerkErrorModal;
